import { render } from "./WhatsappOnboardingProgress.vue?vue&type=template&id=24aa7fef"
import script from "./WhatsappOnboardingProgress.vue?vue&type=script&lang=ts"
export * from "./WhatsappOnboardingProgress.vue?vue&type=script&lang=ts"
script.render = render

export default script